<template>
	<div class="menus-filter-container">
		<div class="menu" :class="{active: !this.notActiveMenus.includes(menu.menu_id)}" v-for="menu in sortedMenus" :key="menu.menu_id" @click="toggleMenu(menu)">
			<p>{{ menu.name && menu.name !== "" ? menu.name : this.getString('no_name_cat') }}</p>
		</div>
	</div>
</template>

<script>
import {useLanguageStore} from "@/shared/stores";
import {useUserStore} from "@/user/stores";
import {useAnalyticsStore, useMenuStore} from "@/console-new/stores";

export default {
	setup() {
		const menuStore = useMenuStore();
		const userStore = useUserStore();
		const analyticsStore = useAnalyticsStore();
		return {getString: useLanguageStore().getString, menuStore, userStore, analyticsStore};
	},
	name: "MultiMenuFilter",
	data() {
		return {
			notActiveMenus: []
		}
	},
	computed: {
		sortedMenus() {
			return this.menuStore.sortedMenus;
		},
		activeMenus() {
			return this.sortedMenus.filter( menu => !this.notActiveMenus.includes(menu.menu_id) );
		}
	},
	methods: {
		toggleMenu(menu) {
			if(this.notActiveMenus.includes(menu.menu_id)) {
				this.notActiveMenus = this.notActiveMenus.filter( id => id !== menu.menu_id );
			} else {
				this.notActiveMenus.push(menu.menu_id);
			}
		},
	},
	mounted() {
		if(this.analyticsStore.activeMenus){
			this.notActiveMenus = Object.values(this.menuStore.menus)
				.filter(menu => !this.analyticsStore.activeMenus.includes(menu.menu_id))
				.map(menu => menu.menu_id);
		}
	}
}
</script>

<style scoped lang="scss">
.menus-filter-container {
	border-radius: 13px;
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
	padding: 12px;
	gap: 12px;

	.menu {
		border-radius: 13px;
		border: 1px solid var(--color-primary);
		padding: 0 12px;
		max-width: 130px;
		width: fit-content;
		cursor: pointer;
		user-select: none;
		transition: background-color 0.3s ease;
		height: 50px;
		display: flex;
		align-items: center;

		p {
			@include truncateString(1);
			font-size: 13px;
			color: $primary;
		}

		&.active {
			background-color: var(--color-active-button);
			p {
				color: var(--color-active-button-text);
			}
		}
	}

	@media (max-width: 900px) {
		padding: 8px;
		gap: 8px;

		.menu {
			padding: 0 8px;
		}
	}

}
</style>